<template>
  <pt-goods-of-integral ref="table" class="pt-goods-of-integral__withData" :goodsTypes="goodsTypes" :goodsGroup="goodsGroup" @recommendChange="recommendChange" @stickyChange="stickyChange"
  @integralGoodsApproval="integralGoodsApproval" @goodsDelete="goodsDelete"></pt-goods-of-integral>
</template>

<script>
import PtGoodsOfIntegral from './index'
export default {
  name: 'pt-goods-of-integral__withData',
  components: {
    'pt-goods-of-integral': PtGoodsOfIntegral
  },
  data () {
    return {
      goodsGroup: [],
      goodsTypes: []
    }
  },
  methods: {
    integralGoodsApproval (id) {
      this.$store.dispatch('integralGoodsApproval', id).then(res => {
        this.$message.success('提交审核成功')
        this.$refs.table.getTableData()
      }).catch(err => {
        this.$message.error(err || '提交审核失败')
      })
    },
    recommendChange (val) {
      let isRecommend = val.goodsOtherInfoDTO.recommend
      let id = val.goodsDTO.id
      let apiUrl = isRecommend ? 'integralCancelRecommend' : 'integralRecommend'
      let text = isRecommend ? '取消商品首页展示' : '设置商品为首页展示'
      this.$store.dispatch(apiUrl, id).then(res => {
        this.$message.success(text + '成功')
        val.goodsOtherInfoDTO.recommend = !isRecommend
      }).catch(err => {
        this.$message.error(err || (text + '失败'))
      })
    },
    stickyChange (val) {
      let isSticky = val.goodsOtherInfoDTO.sticky
      let id = val.goodsDTO.id
      let apiUrl = isSticky ? 'integralGoodsCancelStick' : 'integralGoodsStick'
      let text = isSticky ? '取消商品置顶' : '设置商品置顶'
      this.$store.dispatch(apiUrl, id).then(res => {
        val.goodsOtherInfoDTO.sticky = !isSticky
        this.$message.success(text + '成功')
      }).catch(err => {
        this.$message.error(err || (text + '失败'))
      })
    },
    // 根据商品归属获取商品类型列表
    getGoodsTypeList (belong) {
      this.goodsTypeLoading = true
      this.$store.dispatch('getIntergralGoodsTypesOfAll').then(res => {
        this.goodsTypeLoading = false
        this.goodsTypes = res
      }).catch(err => {
        this.goodsTypeLoading = false
        this.$message.error(err || '获取商品类型列表失败')
      })
    },

    // 获取商品分组列表
    getGoodsGroup () {
      let data = {
        example: {},
        pageable: {
          page: 0,
          size: 1000
        }
      }
      this.$store.dispatch('getIntegralGoodsGroups', data).then(res => {
        res.data.forEach(item => {
          if (!item.id !== 'goods-share') {
            this.goodsGroup.push(item)
          }
        })
      }).catch(err => {
        this.$message.error(err || '获取商品分组列表失败')
      })
    },
    goodsDelete (id) {
      this.$store.dispatch('deleteIntegralGoods', id).then(res => {
        this.$message.success('删除积分商品成功')
        this.$refs.table.getTableData()
      }).catch(err => {
        this.$message.error(err || '删除积分商品失败')
      })
    }
  },
  created () {
    this.getGoodsTypeList()
    this.getGoodsGroup()
  }
}
</script>
